import React from 'react';
import { Users, AlertTriangle, CheckCircle, Clock } from 'lucide-react';
export function SupplierStats() {
  const stats = [{
    title: 'Total Suppliers',
    value: '234',
    change: '+12',
    changeType: 'positive',
    icon: Users,
    color: 'blue'
  }, {
    title: 'Non-Compliant',
    value: '15',
    change: '-3',
    changeType: 'positive',
    icon: AlertTriangle,
    color: 'red'
  }, {
    title: 'Fully Compliant',
    value: '187',
    change: '+15',
    changeType: 'positive',
    icon: CheckCircle,
    color: 'green'
  }, {
    title: 'Certifications Expiring',
    value: '28',
    change: '+5',
    changeType: 'negative',
    icon: Clock,
    color: 'yellow'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-72">
      {stats.map((stat, index) => <div key={index} className="bg-white rounded-lg border p-6" data-id="element-73">
          <div className="flex items-center justify-between" data-id="element-74">
            <div data-id="element-75">
              <p className="text-sm text-gray-600 mb-1" data-id="element-76">{stat.title}</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-77">
                {stat.value}
              </p>
              <div className="flex items-center mt-2" data-id="element-78">
                <span className={`text-sm ${stat.changeType === 'positive' ? 'text-green-600' : 'text-red-600'}`} data-id="element-79">
                  {stat.change} this month
                </span>
              </div>
            </div>
            <div className={`p-3 rounded-lg ${stat.color === 'blue' ? 'bg-blue-100' : stat.color === 'red' ? 'bg-red-100' : stat.color === 'green' ? 'bg-green-100' : 'bg-yellow-100'}`} data-id="element-80">
              <stat.icon className={`w-6 h-6 ${stat.color === 'blue' ? 'text-blue-600' : stat.color === 'red' ? 'text-red-600' : stat.color === 'green' ? 'text-green-600' : 'text-yellow-600'}`} data-id="element-81" />
            </div>
          </div>
        </div>)}
    </div>;
}